<template>
  <div class="test-mermaid-page">
    <h2>Mermaid 图表测试</h2>
    
    <div class="test-section">
      <h3>测试1: 流程图</h3>
      <UnifiedMessageRenderer :content="flowChartContent" />
    </div>

    <div class="test-section">
      <h3>测试2: 时序图</h3>
      <UnifiedMessageRenderer :content="sequenceContent" />
    </div>

    <div class="test-section">
      <h3>测试3: 甘特图</h3>
      <UnifiedMessageRenderer :content="ganttContent" />
    </div>

    <div class="test-section">
      <h3>测试4: 混合内容</h3>
      <UnifiedMessageRenderer :content="mixedContent" />
    </div>
  </div>
</template>

<script>
import UnifiedMessageRenderer from '@/components/message/UnifiedMessageRenderer.vue';

export default {
  name: 'TestMermaid',
  
  components: {
    UnifiedMessageRenderer
  },
  
  data() {
    return {
      flowChartContent: `## 流程图示例

\`\`\`mermaid
graph TD
    A[开始] --> B{是否登录?}
    B -->|是| C[进入系统]
    B -->|否| D[跳转登录]
    C --> E[操作完成]
    D --> F[输入账号密码]
    F --> B
\`\`\`

这是一个简单的登录流程图。`,

      sequenceContent: `## 时序图示例

\`\`\`mermaid
sequenceDiagram
    participant 用户
    participant 前端
    participant 后端
    participant 数据库
    
    用户->>前端: 点击登录
    前端->>后端: 发送登录请求
    后端->>数据库: 查询用户信息
    数据库-->>后端: 返回用户数据
    后端-->>前端: 返回登录结果
    前端-->>用户: 显示登录状态
\`\`\``,

      ganttContent: `## 甘特图示例

\`\`\`mermaid
gantt
    title 项目开发计划
    dateFormat  YYYY-MM-DD
    section 设计阶段
    需求分析        :a1, 2024-01-01, 7d
    UI设计          :after a1, 5d
    section 开发阶段
    前端开发        :2024-01-10, 10d
    后端开发        :2024-01-12, 8d
    section 测试阶段
    单元测试        :2024-01-20, 3d
    集成测试        :2024-01-23, 5d
\`\`\``,

      mixedContent: `# Markdown 与 Mermaid 混合测试

这是一段普通的 **Markdown** 文本，包含一些 *斜体* 和 \`代码\`。

## 1. 列表测试

- 项目一
- 项目二
  - 子项目 A
  - 子项目 B
- 项目三

## 2. 代码块测试

\`\`\`javascript
function hello() {
  console.log("Hello, World!");
}
\`\`\`

## 3. Mermaid 图表

\`\`\`mermaid
graph LR
    A[输入] --> B[处理]
    B --> C[输出]
    B --> D[日志]
\`\`\`

## 4. 表格测试

| 功能 | 状态 | 说明 |
|------|------|------|
| Markdown | ✅ | 正常渲染 |
| Mermaid | 🔧 | 测试中 |
| 代码高亮 | ✅ | 支持多种语言 |

## 5. 数学公式

行内公式：$E = mc^2$

块级公式：

$$
\\frac{1}{\\sqrt{2\\pi\\sigma^2}} e^{-\\frac{(x-\\mu)^2}{2\\sigma^2}}
$$
`
    };
  }
};
</script>

<style lang="scss" scoped>
.test-mermaid-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  
  h2 {
    color: #333;
    margin-bottom: 30px;
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
  }
  
  .test-section {
    margin-bottom: 40px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    
    h3 {
      color: #0066cc;
      margin-bottom: 20px;
    }
  }
}
</style>